module.exports = __webpack_public_path__ + "img/logo.1eff0d83.png";